import { Card, CardBody, Col } from "reactstrap";
import { Blockquotes } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BLOCKQUOTS_DATA } from "../../../../Data/UiKit/Typography";
import { StaticBlockQuots } from "./StaticBlockQuots";
import { DynamicBlockquotes } from "./DynamicBlockquotes";

const BlockQuotsCart = () => {
  return (
    <Col sm="12">
      <Card className="overflow-hidden">
        <CommonCardHeader title={Blockquotes} span={BLOCKQUOTS_DATA} />
        <CardBody>
          <StaticBlockQuots />
          <DynamicBlockquotes />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BlockQuotsCart;
